import { dateToServer } from 'helpers/formatters/date';
import { CalculationFrequency } from 'modules/BenchmarkForm';
import {
  AssetWeighted,
  AssetWeightedForm,
  AssetWeightedLineItem,
  AssetWeightedTimeWindow,
  AssetWeightedTimeWindowForm,
} from 'types/AssetWeighted';
import { BenchmarkTypes } from 'types/Benchmark';

const mapTimeWindow = (data: AssetWeightedTimeWindowForm) => {
  const timeWindow: AssetWeightedTimeWindow = {
    fromDate: dateToServer(new Date(data.fromDate)),
    lineItems: data.lineItems.map((lineItem) => {
      const li: AssetWeightedLineItem = {
        isLagged: false,
      };

      if (
        typeof lineItem.weightingComponent === 'string' &&
        lineItem.weightingComponent.includes('-')
      ) {
        li.weightingComponentBenchmarkId = lineItem.weightingComponent;
      } else {
        li.weightingComponentResourceId = Number(lineItem.weightingComponent);
      }
      if (
        typeof lineItem.returnComponent === 'string' &&
        lineItem.returnComponent.includes('-')
      ) {
        li.returnComponentBenchmarkId = lineItem.returnComponent;
      } else {
        li.returnComponentResourceId = Number(lineItem.returnComponent);
      }

      li.isLagged = lineItem.isLagged;
      li.customLagDate = lineItem.customLagDate;
      li.defaultLagDate = lineItem.defaultLagDate;

      return li;
    }),
  };

  return timeWindow;
};

const parseBoolean = (value: string | boolean): boolean => {
  switch (typeof value) {
    case 'string':
      return JSON.parse(value);

    case 'boolean':
    default:
      return value;
  }
};

export function getBody(
  originalValues: AssetWeighted,
  newValues: AssetWeightedForm,
  originalTimeWindows?: Array<AssetWeightedTimeWindow>
): AssetWeighted {
  const timeWindows = newValues.timeWindows.map(mapTimeWindow);

  return {
    id: originalValues?.id,
    name: newValues.name,
    typeId: BenchmarkTypes.AssetWeighted,
    calculationFrequencyId:
      newValues.calculationFrequency?.id ?? newValues.calculationFrequencyId,
    baseCurrencyCode: newValues.baseCurrencyCode,
    weightingMethodologyId:
      newValues.weightingMethodology?.id ?? newValues.weightingMethodologyId,
    portfolioAnalyticsCalendarId:
      newValues.calculationFrequencyId === CalculationFrequency.day ||
      newValues.calculationFrequency?.id === CalculationFrequency.day
        ? newValues.portfolioAnalyticsCalendarId
        : undefined,
    includeBookedValues: parseBoolean(newValues.includeBookedValues)
      ? true
      : false,
    isLagged: parseBoolean(newValues.isLagged) ? true : false,
    customLagDate: newValues.customLagDate ?? null,
    description: newValues.description,
    performanceVariationCode: newValues.performanceVariationCode,
    timeWindows,
    useLocalCurrencyReturns: parseBoolean(newValues.useLocalCurrencyReturns) ? true : false
  };
}
